/**
 * customer-bootstrap · 入口
 *
 * 唯一允许做 DOM 组装 + 串联的文件。
 *   - 不写业务逻辑（业务在 customer-app.bundle.js）
 *   - 不写网络细节（在 service.ts）
 *   - 不写无副作用工具（在 utils.ts）
 *
 * 来源：原 index.html 内联脚本已迁至本模块 + js/bootstrap-preflight.js（preflight）。
 */

import { FORCE_LOGOUT_INITIAL_DELAY_MS, RESTORE_NOTIFY_DELAYS_MS, STORAGE_KEYS } from './types';
import {
  connectForceLogoutWs,
  notifyTableOccupied,
  readCurrentSession,
} from './service';
import { applyPreflight } from './preflight';
import { initDebugLog } from './debug';

export { applyPreflight, initPreflight } from './preflight';

/* ─────────── 2. 密码闸：由 js/auth-controller.js 在 #auth-container 注入后绑定 ─────────── */
/* ─────────── 3. 登录提交 → 上报占用：auth-controller 监听；bootstrap 写 window.OS.hooks.notifyTableOccupied（global-store 会合并） ─────────── */

/* ─────────── 4. 刷新恢复：补一次占用通知 ─────────── */
const scheduleRestoreNotify = (): void => {
  RESTORE_NOTIFY_DELAYS_MS.forEach((ms) => {
    setTimeout(() => {
      if (readCurrentSession()) notifyTableOccupied();
    }, ms);
  });
};

/* ─────────── 5. 强制登出 WS ─────────── */
const initForceLogoutWs = (): void => {
  setTimeout(connectForceLogoutWs, FORCE_LOGOUT_INITIAL_DELAY_MS);
  try {
    window.addEventListener('storage', (e) => {
      if (e.key === STORAGE_KEYS.networkConfig) connectForceLogoutWs();
    });
  } catch {
    /* noop */
  }
};

/* ─────────── 6. main ─────────── */
export const bootstrap = (): void => {
  /**
   * osDebug 必须最先注册，错误监听器越早装上、捕获面越大。
   * 未带 ?osDebug=1 时函数体内立即 return，零成本。
   */
  initDebugLog();

  /** 双保险：如果 inline preflight 没执行（被 CSP 拦了等），bundle 阶段补一次。 */
  applyPreflight();

  /** 供 js/auth-controller.js 读取 `OS.hooks.notifyTableOccupied`（defer 早于 DOMContentLoaded；见 global-store 合并 hooks） */
  try {
    const w = window as Window & {
      OS?: { hooks?: Record<string, unknown> };
    };
    if (!w.OS) w.OS = {};
    if (!w.OS.hooks) w.OS.hooks = {};
    w.OS.hooks.notifyTableOccupied = notifyTableOccupied;
  } catch {
    /* noop */
  }

  scheduleRestoreNotify();
  initForceLogoutWs();
};

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
}
